var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileFolderPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ansrwisgla",
    d: "M0 0H32V32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-544.000000, -440.000000) translate(544.000000, 440.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.333 12v4h4v2.667h-4v4h-2.666v-4h-4V16h4v-4h2.666zm-.781-5.333h10.115c1.47 0 2.666 1.196 2.666 2.666v16c0 1.471-1.196 2.667-2.666 2.667H5.333c-1.47 0-2.666-1.196-2.666-2.667V6.667C2.667 5.196 3.863 4 5.333 4h8c.355 0 .694.14.943.39l2.276 2.277zM5.333 9.333v16H26.67l-.002-16H5.333z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFolderPlus);
export default __webpack_public_path__ + "static/media/file-folder-plus.ca7472a2.svg";
export { ForwardRef as ReactComponent };